import SortImagesAssetsLoader from '../../RealTimeActivity/Players/SortImagesActivity/SortImagesAssetsLoader/SortImagesAssetsLoader';
import GameSpinner from '@/shared/GameComponents/UI/GameSpinner/GameSpinner';
import useSortImagesGameActivity from './useSortImagesGameActivity.hook';
import { useContext } from 'react';
import { StyledSortImagesGameActivity } from './SortImagesGameActivity.styled';
import { FullscreenContext } from '@/shared/FullscreenContext/FullscreenContext';
import AudioAutoPlayer from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayer';
import ConceptQuestActivity from './ConceptQuestActivity/ConceptQuestActivity';
import CoverMenu from './CoverMenu/CoverMenu';
import TrainingActivity from './TrainingActivity/TrainingActivity';
import { GameControlBar } from '../GameControlBar/GameControlBar';

export default function SortImagesGameActivity({
  activity,
  activityConf,
  taskActivityConf,
  initialTaskProgress,
  taskProgressActions,
  demoMode,
  forceRestart,
}) {
  const fullscreenContext = useContext(FullscreenContext);

  const { state, actions } = useSortImagesGameActivity({
    activity,
    activityConf,
    taskProgressActions,
    forceRestart,
  });

  return (
    <>
      {activity ? (
        <SortImagesAssetsLoader activity={activity}>
          <StyledSortImagesGameActivity
            className={`${
              fullscreenContext.state.isFullscreen ? 'fullscreen' : ''
            }`}
            key={activity.id}
          >
            <div className="game-container">
              <div className="game-activity">
                {
                  {
                    COVER: (
                      <CoverMenu
                        activity={activity}
                        activityConf={state.activityConf}
                        gameActions={{
                          setGameConf: actions.setGameConf,
                          startGame: actions.startGame,
                        }}
                        starting={state.preparingProgress}
                        disabled={state.preparingProgress}
                      />
                    ),
                    GAME: {
                      training: (
                        <TrainingActivity
                          key={
                            state.activityConf.miniactivityType + state.gameKey
                          }
                          activity={activity}
                          initialTaskProgress={
                            initialTaskProgress?.miniactivityType ==
                            state.activityConf.miniactivityType
                              ? initialTaskProgress
                              : null
                          }
                          taskProgressAPI={actions.taskProgressAPI}
                          onFinishedActivity={actions.onFinishedActivity}
                        />
                      ),
                      conceptQuest: (
                        <ConceptQuestActivity
                          key={
                            state.activityConf.miniactivityType + state.gameKey
                          }
                          activity={activity}
                          activityConf={activityConf}
                          taskActivityConf={taskActivityConf}
                          initialTaskProgress={
                            initialTaskProgress?.miniactivityType ==
                            state.activityConf.miniactivityType
                              ? initialTaskProgress
                              : null
                          }
                          taskProgressAPI={actions.taskProgressAPI}
                          onFinishedActivity={actions.onFinishedActivity}
                          restartGame={actions.restartGame}
                        />
                      ),
                    }[state.activityConf.miniactivityType],
                  }[state.screen]
                }
              </div>
              <GameControlBar
                state={state}
                actions={actions}
                activityConf={activityConf}
              />
            </div>
          </StyledSortImagesGameActivity>
        </SortImagesAssetsLoader>
      ) : (
        <GameSpinner />
      )}
      <AudioAutoPlayer />
    </>
  );
}
